import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fa } from 'vuetify/iconsets/fa'
import { aliases, md } from 'vuetify/iconsets/md'

import 'material-design-icons-iconfont/dist/material-design-icons.css'

import theme from './vuetifyTheme'

export const defaultVuetifyComponentsStyle = {
    VDataTableServer: {
        noDataText: '',
        loadingText: '',
    },
    VBtn: {
        class: 'text-uppercase',
        style: 'letter-spacing: .0892857143em;',
    },
}

// eslint-disable-next-line ts/ban-ts-comment
// @ts-ignore
export const defaultVuetifyConfig = {
    components,
    directives,
    icons: {
        defaultSet: 'md',
        aliases,
        sets: { fa, md },
    },
    theme,
    defaults: defaultVuetifyComponentsStyle,
}

// eslint-disable-next-line ts/ban-ts-comment
// @ts-ignore
export default createVuetify(defaultVuetifyConfig)
